import SpecialSale from 'src/dispensary/specials/sale';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(SpecialSale, CoreMenuLayout);
